import { FaAlignLeft } from "react-icons/fa6";
import { useDispatch } from "react-redux";

import { toggleShow } from "../../sotre/redux/features/toggleMenuSlice";
import TotalPendigOrder from "./TotalPendigOrder";
import TotalPendingVendore from "./TotalPendingVendore";
import Profile from "./sub-components/profile/Profile";
import Theme from "./sub-components/theme/Theme";
import { useAdminAccess } from "../access/AdminAccessContext";

export default function Header() {
  const dispatch = useDispatch();
  const { canVisit, isAdmin } = useAdminAccess();

  return (
    <div className="admin-header sticky top-0 right-0 z-[25] mx-auto mb-4 flex min-h-16 w-11/12 items-center justify-between rounded-2xl bg-white px-5 shadow-lg shadow-slate-900/5 dark:bg-slate-900">
      <Profile />
      <div className="flex justify-center items-center gap-x-4">
        <FaAlignLeft
          onClick={() => dispatch(toggleShow())}
          size={26}
          className="lg:hidden text-gray-600 dark:text-white cursor-pointer"
        />
        {canVisit("/order-list") && <TotalPendigOrder />}
        {isAdmin && canVisit("/vendor-stores-list") && <TotalPendingVendore />}
        {/* <Notification /> */}
        <Theme />
      </div>
    </div>
  );
}
